import React from 'react';
import { ContentFlag, Content } from '../../apiService';
import { __t } from '../../i18n';
import {
  IconAudio,
  IconAudioBook,
  IconBrand,
  IconCamQuality,
  IconCinema,
  IconDeafSubtitle,
  IconSubtitle,
  MuteIcon,
  TheaterIcon,
} from '../../icons';
import Icon4k from '../../icons/Icon4k';
import IconComingSoon from '../../icons/IconComingSoon';
import IconHd from '../../icons/IconHd';
import IconMultiAudio from '../../icons/IconMultiAudio';
import { Row, Flag, Icon, Flex } from '../../styles';
import DurationFlag from '../../DurationFlag';
import CountryYear from '../../CountryYear';

const icons = {
  coming_soon: <IconComingSoon />,
  has_subtitle: <IconSubtitle />,
  has_deaf_subtitle: <IconDeafSubtitle />,
  persian_dub: <IconAudio />,
  hd: <IconHd />,
  _4_k: <Icon4k />,
  multi_audio: <IconMultiAudio />,
  exclusive_dub: <IconAudio />,
  in_production: <IconBrand />,
  cinema_online: <IconCinema />,
  audio_book: <IconAudioBook />,
  silent_film: <MuteIcon/>,
  theater_film: <TheaterIcon/>,
  cam_quality: <IconCamQuality />,
};

export default function ValidFlags({ duration, year, categories, flag }: Pick<Content, 'duration' | 'year' | 'categories' | 'flag'>) {
  const flags = flag?.split(', ') as ContentFlag[];
  const validFlags: ContentFlag[] = [
    'coming_soon',
    'has_subtitle',
    'has_deaf_subtitle',
    'persian_dub',
    'hd',
    '4_k',
    'multi_audio',
    'exclusive_dub',
    'in_production',
    'cinema_online',
    'audio_book',
    'silent_film',
    'theater_film',
    'cam_quality',
  ];
  const comingSoon = flag?.includes('coming_soon');
  return (
    <Row gap={2} mb={1}>
      <Flex>
        {!comingSoon && duration && <DurationFlag duration={duration} />}
        <CountryYear year={year} categories={categories} />
      </Flex>
      {flags
        .filter((f) => validFlags.includes(f))
        .map((item) => (
          <Flag key={item}>
            <Icon size={item === 'has_deaf_subtitle' ? 'large' : 'inherit'}>{icons[item]}</Icon> {__t('flag.' + item)}
          </Flag>
        ))}
    </Row>
  );
}
